/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'omino-1': {
    width: 24,
    height: 55,
    viewBox: '0 0 24 55',
    data: '<g _stroke="#4A4A4A" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M6.482 33.636H3.218a1.991 1.991 0 0 1-2-1.985l.025-10.86c.009-2.996 2.491-5.44 5.516-5.43l11.081.032c3.026.009 5.493 2.47 5.484 5.465l-.026 10.866a1.992 1.992 0 0 1-2 1.98h-3.244"/><path pid="1" d="M18.056 22.138v28.378c0 1.773-1.395 3.207-3.116 3.207H9.6c-1.72 0-3.115-1.434-3.115-3.207V22.138M12.27 53.471V36.706M16.921 7.312c.022.183.033.37.033.558 0 2.563-2.096 4.64-4.684 4.64-2.587 0-4.683-2.077-4.683-4.64 0-.194.011-.386.034-.573M9.876 36.706h4.789M6.747 23.908h11.047M8.83 15.36v8.549M15.71 15.36v8.549M6.616 7.3h11.31"/><path pid="2" d="M14.942 2.19H9.597c-1.11 0-2.01.891-2.01 1.99V7.3h9.367V4.18c0-1.099-.9-1.99-2.012-1.99zM12.265.644v4.1"/></g>'
  }
})
